import React, { useState, useCallback, useEffect } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleChevronLeft, faCircleChevronRight, faCircleXmark } from "@fortawesome/free-solid-svg-icons"
import { Link } from "react-router-dom"
import "./multiComponents.css"
import logoMultiComponents from "../../imagens/logos/logoMultiComponents.png"



function MultiComponents({ listMultiComponets }) {
    const [slideNumber, setSlideNumber] = useState(0)
    const [openModal, setOpenModal] = useState(false)


    const handleOpenModal = (index) => {
        setSlideNumber(index)
        setOpenModal(true)
    }

    const handleCloseModal = () => {
        setOpenModal(false)
    }

    const prevSlide = useCallback(() => {
        slideNumber === 0
            ? setSlideNumber(listMultiComponets.length - 1)
            : setSlideNumber(slideNumber - 1)
    }, [slideNumber, listMultiComponets.length])

    const nextSlide = useCallback(() => {
        slideNumber + 1 === listMultiComponets.length
            ? setSlideNumber(0) :
            setSlideNumber(slideNumber + 1)
    }, [slideNumber, listMultiComponets.length])

    useEffect(() => {
        const handleKeyDown = (event) => {
            switch (event.key) {
                case 'Escape':
                    handleCloseModal()
                    break
                case 'ArrowLeft':
                    prevSlide()
                    break;
                case 'ArrowRight':
                    nextSlide()
                    break;
                default:
                    break;
            }
        };

        if (openModal) {
            window.addEventListener('keydown', handleKeyDown);
        }

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [openModal, nextSlide, prevSlide]);



    return (
        <div >
            {
                openModal &&
                <div className="MultiComponentsSliderWrap">
                    <FontAwesomeIcon icon={faCircleXmark} className="MultiComponentsBtnClose" onClick={() => handleCloseModal()} />
                    <FontAwesomeIcon icon={faCircleChevronLeft} className="MultiComponentsBtnPrev" onClick={() => prevSlide()} />
                    <FontAwesomeIcon icon={faCircleChevronRight} className="MultiComponentsBtnNext" onClick={() => nextSlide()} />
                    <img className="MultiComponentsFullScreenImage" src={listMultiComponets[slideNumber].img} alt="" />
                </div>
            }
            <div className='img-custom-size img-fluid ms-2'>
                <img src={logoMultiComponents} alt='logoCapabilities'></img>
            </div>
            <div className="MultiComponentsGalleryWrap">
                {
                    listMultiComponets && listMultiComponets.map((image, index) => {
                        return (
                            <div
                                className="MultiComponentsSingle"
                                key={index}
                                onClick={() => handleOpenModal(index)}
                            >
                                <img src={image.img} alt="MultiComponents" />

                            </div>
                        )
                    })
                }
            </div>
            <div className="text-center text-nowrap my-4">
                <Link to="/Capabilities/Engineer">
                    <button className="buttonCapabilities">Back to Engineer Capabilities</button>
                </Link>
            </div>
        </div>
    )
}

export default MultiComponents